(function ($) {
  'use strict';

  function bindTrackpadSwipe($wrap, $track) {
    var el = $wrap[0];
    if (!el) return;

    if (el._smCarouselWheel) {
      el.removeEventListener('wheel', el._smCarouselWheel);
    }

    var accumulated = 0;
    var threshold = 45;
    var lockUntil = 0;

    var handler = function (e) {
      var deltaX = e.deltaX;
      var deltaY = e.deltaY;

      if (Math.abs(deltaX) < 5 || Math.abs(deltaX) < Math.abs(deltaY)) {
        return;
      }

      e.preventDefault();

      var now = Date.now();
      if (now < lockUntil) return;

      accumulated += deltaX;

      if (accumulated >= threshold) {
        $track.trigger('next.owl.carousel');
        accumulated = 0;
        lockUntil = now + 400;
      } else if (accumulated <= -threshold) {
        $track.trigger('prev.owl.carousel');
        accumulated = 0;
        lockUntil = now + 400;
      }
    };

    el.addEventListener('wheel', handler, { passive: false });
    el._smCarouselWheel = handler;
  }

  function initSmProductCarousel() {
    $('.sm-product-carousel__slider-wrap').each(function () {
      var $wrap = $(this);
      var $track = $wrap.find('[data-sm-product-carousel]');

      if ($track.length === 0 || $track.children().length === 0) {
        return;
      }

      if ($track.hasClass('owl-loaded')) {
        $track.trigger('destroy.owl.carousel');
        $track.removeClass('owl-carousel owl-loaded owl-drag owl-grab owl-theme');
      }

      $track.addClass('owl-carousel').owlCarousel({
        items: 4,
        loop: false,
        nav: false,
        dots: false,
        margin: 20,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        responsive: {
          0: {
            items: 1,
            margin: 0
          },
          750: {
            items: 2,
            margin: 16
          },
          990: {
            items: 3,
            margin: 18
          },
          1200: {
            items: 4,
            margin: 20
          }
        }
      });

      bindTrackpadSwipe($wrap, $track);

      $wrap.find('[data-sm-carousel-prev]').off('click.smCarousel').on('click.smCarousel', function () {
        $track.trigger('prev.owl.carousel');
      });

      $wrap.find('[data-sm-carousel-next]').off('click.smCarousel').on('click.smCarousel', function () {
        $track.trigger('next.owl.carousel');
      });
    });
  }

  $(document).ready(initSmProductCarousel);
  document.addEventListener('shopify:section:load', initSmProductCarousel);
})(jQuery);
